module.exports = __webpack_public_path__ + "img/Brille.83663aea.svg";